export default __webpack_public_path__ + "static/media/6.7.5ead6bd7.mp3";